"use client";

import React from "react";
import { Box } from "@mui/material";
import { Typography } from "../wrappers/Typography";
import { useIsVariant } from "@/hooks/useVariant";
import Image from "next/image";
import { useDealership } from "@/contexts/DealershipContext";
import { getProvincialAssociationLogos } from "@/utils/provincialAssociations";

const Footer: React.FC = () => {
    const currentYear = new Date().getFullYear();
    const isCada = useIsVariant("cada");
    const { participantInfo } = useDealership();
    // CADA: show the dealer's provincial association logo, resolved by province
    // (NCDA is BC's association, MDA is AB's, MVRO is ON's, etc.). [ES-1008]
    const provincialLogos = isCada
        ? getProvincialAssociationLogos(participantInfo?.state, participantInfo?.zip_code)
        : [];

    return (
        <Box component="footer" sx={{ p: 2, flexShrink: 0, mt: "auto" }}>
            <Box
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                    color: "text.secondary",
                    flexWrap: "wrap",
                    gap: 2,
                }}
            >
                <Box flexDirection="row" display="flex" gap={3}>
                    <a
                        style={{ width: 80, height: 40, display: "block", position: "relative" }}
                        href="https://www.esiq.ai"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <Image
                            src="/esiq-logo.png"
                            alt="ESIQ Logo"
                            fill
                            style={{ objectFit: "contain" }}
                        />
                    </a>
                    {isCada ? (
                        <>
                            <a
                                style={{
                                    width: 80,
                                    height: 40,
                                    display: "block",
                                    position: "relative",
                                }}
                                href="https://cadaworkforcestudy.com/"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                <Image
                                    src="/MNP_logo.png"
                                    alt="MNP Logo"
                                    fill
                                    style={{ objectFit: "contain" }}
                                />
                            </a>
                            {provincialLogos.map((logo) => (
                                <div
                                    key={logo.key}
                                    style={{
                                        width: 80,
                                        height: 40,
                                        display: "block",
                                        position: "relative",
                                    }}
                                >
                                    <Image
                                        src={logo.src}
                                        alt={`${logo.key} Logo`}
                                        fill
                                        style={{ objectFit: "contain" }}
                                    />
                                </div>
                            ))}
                        </>
                    ) : null}
                </Box>
                {isCada ? (
                    <Typography
                        tx="ui.footer.copyright.cada"
                        txOptions={{ year: currentYear }}
                        sx={{ alignSelf: "flex-end" }}
                        variant="caption"
                    >
                        {/* ©{`CADA 2021-${currentYear}. All rights reserved.`} */}
                    </Typography>
                ) : (
                    <Typography
                        tx="ui.footer.copyright.nada"
                        txOptions={{ year: currentYear }}
                        sx={{ alignSelf: "flex-end" }}
                        variant="caption"
                    >
                        {/* © {`NADA 2012–${currentYear}. All rights reserved.`} */}
                    </Typography>
                )}
            </Box>
        </Box>
    );
};

export default Footer;
